import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, makeStyles } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import PIMButton from '../shared/Components/PIMButton';

interface IProps {
  handleClose: () => void;
  delete: () => void;
  open: boolean;
  fullScreen: boolean;
  saveText: string;
  title: string;
}

export function DeleteDialog(props: IProps): JSX.Element {
  const classes = useStyles();
  const { t } = useTranslation();
  return (
    <Dialog
      fullScreen={props.fullScreen}
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby='responsive-dialog-title'
      className={classes.dialog}>
      <DialogTitle id='responsive-dialog-title'>
        <span className={classes.title}>{props.title}</span>
      </DialogTitle>
      <DialogContent>
        <DialogContentText className={classes.font}>
          <span className={classes.font}>{props.saveText}</span>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <PIMButton onClick={props.handleClose} autoFocus>
          {t('Abbrechen')}
        </PIMButton>
        <PIMButton onClick={props.delete} className={classes.deleteButton} color='warning' icon='trash' autoFocus>
          {t('Löschen')}
        </PIMButton>
      </DialogActions>
    </Dialog>
  );
}

const useStyles = makeStyles(() => ({
  dialog: {
    padding: '32px',
    '& .MuiDialog-paperWidthSm': {
      padding: '32px',
    },
  },
  title: {
    fontSize: '24px',
    fontWeight: 'bold',
  },
  font: {
    color: 'black',
    fontSize: '18px',
  },
  deleteButton: {
    paddingLeft: '16px',
  },
}));
